var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataActivityWifiActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cmpnts / KW42 / SVG / data_activity_wifi_active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cmpnts-/-KW42-/-SVG-/-data_activity_wifi_active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,26.0001 L46,32.0001 L41,32.0001 L41,44.0001 L39,44.0001 L39,32.0001 L34,32.0001 L40,26.0001 Z M31,26.0001 L31,38.0001 L36,38.0001 L30,44.0001 L24,38.0001 L29,38.0001 L29,26.0001 L31,26.0001 Z M23.9998,27 C24.7012133,27 25.3744946,27.1204127 26.0001502,27.341593 L25.999,30.9991 L23.9998,33 L19.7568,28.757 C20.8428,27.672 22.3428,27 23.9998,27 Z M24.0001,18.9997 C27.7327897,18.9997 31.1242855,20.4604943 33.6345408,22.8411361 L33.797,22.9991 L24,23.0001 C21.357975,22.9997 18.9518795,24.0301479 17.1629124,25.7099449 L16.9331,25.9327 L14.1011,23.1007 C16.6341,20.5667 20.1341,18.9997 24.0001,18.9997 Z M24.0029,11.0001 C29.9162846,11.0001 35.290424,13.3374623 39.2465373,17.1408062 L39.5559,17.4441 L36.7149,20.2851 C33.5488412,17.1200118 29.218419,15.1202289 24.4386431,15.0053326 L24.0029,15.0001 L23.8949,15.0001 C19.2665364,15.0272515 14.9183858,16.7911597 11.5853734,19.9717764 L11.2759,20.2741 L8.4459,17.4451 C12.2955923,13.5954077 17.5646009,11.1631329 23.408371,11.0076307 L23.8709,11.0001 L24.0029,11.0001 Z M24,3.0001 C32.1149388,3.0001 39.477551,6.22243736 44.8780355,11.4573109 L45.213,11.7871 L42.376,14.6241 C37.668,9.9161 31.168,7.0001 24,7.0001 C16.9912889,7.0001 10.6212188,9.78794 5.94050915,14.3129005 L5.624,14.6241 L2.787,11.7871 C8.216,6.3581 15.716,3.0001 24,3.0001 Z",
    id: "data_activity_wifi_active",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataActivityWifiActive);
export default __webpack_public_path__ + "static/media/data_activity_wifi_active.ad2905de78958d85d161ecef18c49214.svg";
export { ForwardRef as ReactComponent };